import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Toggle from 'components/Toggle/Toggle';
import SearchUnitCustomControlCalendar from 'components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendar';
import MonthCalendar from 'components/MonthCalendar/MonthCalendar';
import {
  flexibilityItems,
  ZERO_DAY_FLEXIBILITY_VALUE,
  MONTH_FLEXIBILITY_VALUE,
} from 'constants/searchUnit';
import * as optimizelyUtil from 'utils/optimizely';

import './SearchUnitCustomControlCalendarToggle.desktop.scss';
import './SearchUnitCustomControlCalendarToggle.mobile.scss';

export default class SearchUnitCustomControlCalendarToggle extends Component {
  static propTypes = {
    monthViewDayStamp: PropTypes.number.isRequired,
    handleDayClick: PropTypes.func.isRequired,
    handleMonthClick: PropTypes.func.isRequired,
    selectedCalendarDayStamp: PropTypes.number.isRequired,
    loadDayOfMonthData: PropTypes.func.isRequired,
    dimensionsEntities: ImmutablePropTypes.map.isRequired,
    dimensionsResult: ImmutablePropTypes.map.isRequired,
    availability: ImmutablePropTypes.list.isRequired,
    hideLegend: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    selectedFlexibility: PropTypes.number.isRequired,
  };

  state = {
    showMonthCalendar: false,
  };

  componentWillMount() {
    const { selectedFlexibility } = this.props;
    if (selectedFlexibility === MONTH_FLEXIBILITY_VALUE) {
      this.setState({
        showMonthCalendar: true,
      });
    }
  }

  toggleMonthCalendar = () => {
    this.setState({
      showMonthCalendar: !this.state.showMonthCalendar,
    });
    optimizelyUtil.fireEvent('SearchByDayOrByMonthPickerToggle', 'clicked');
  };

  handleSpecificDateClick = () => {
    this.setState({
      showMonthCalendar: false,
    });
  };

  handleWholeMonthClick = () => {
    this.setState({
      showMonthCalendar: true,
    });
  };

  get flexibilityLabel() {
    const { selectedFlexibility } = this.props;
    const hiddenFlexibilityValues = [
      ZERO_DAY_FLEXIBILITY_VALUE,
      MONTH_FLEXIBILITY_VALUE,
    ];
    const flexibility = flexibilityItems.find(item => item.value === selectedFlexibility);
    return (flexibility && !hiddenFlexibilityValues.includes(flexibility.value)) ? flexibility.label : '';
  }

  render() {
    const {
      availability,
      loadDayOfMonthData,
      dimensionsEntities,
      dimensionsResult,
      monthViewDayStamp,
      selectedCalendarDayStamp,
      hideLegend,
      handleDayClick,
      handleMonthClick,
      type,
    } = this.props;
    const { showMonthCalendar } = this.state;

    return (
      <div className="search-unit-custom-control-calendar-toggle">
        <div className="search-unit-custom-control-calendar-toggle__heading">
          <div className="search-unit-custom-control-calendar-toggle__heading__specific-date">
            <button className="search-unit-custom-control-calendar-toggle__heading__button" onClick={this.handleSpecificDateClick}>
              Specific date
            </button>
            <div className="search-unit-custom-control-calendar-toggle__heading__specific-date__flexibility">
              { this.flexibilityLabel }
            </div>
          </div>
          <div className="search-unit-custom-control-calendar-toggle__heading__toggle">
            <div className="search-unit-custom-control-calendar-toggle__heading__toggle-wrapper">
              <Toggle onChange={this.toggleMonthCalendar} checked={showMonthCalendar} />
            </div>
          </div>
          <div className="search-unit-custom-control-calendar-toggle__heading__whole-month">
            <button className="search-unit-custom-control-calendar-toggle__heading__button" onClick={this.handleWholeMonthClick}>
              Whole month
            </button>
          </div>
        </div>
        <div>
          { showMonthCalendar && (
            <MonthCalendar
              onSelectMonth={handleMonthClick}
            />
          )}

          { !showMonthCalendar && (
            <SearchUnitCustomControlCalendar
              monthViewDayStamp={monthViewDayStamp}
              handleDayClick={handleDayClick}
              selectedCalendarDayStamp={selectedCalendarDayStamp}
              loadDayOfMonthData={loadDayOfMonthData}
              dimensionsEntities={dimensionsEntities}
              dimensionsResult={dimensionsResult}
              availability={availability}
              type={type}
              hideLegend={hideLegend}
            />
          )}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendarToggle.jsx
 **/